import { useThemesQuery } from '~/api/graphql/queries/themes.generated';
import { useThemeStore } from '~/stores/theme';
import { useShopStore } from '~/stores/shop';
import { useMemo } from 'react';

export const useQueryThemeInfo = () => {
  const setTheme = useThemeStore((state) => state.setTheme);
  const getThemeId = useThemeStore((state) => state.getTheme()?.id);
  const shopInfo = useShopStore((state) => state.shopInfo);

  useThemesQuery(
    { first: 1, where: { isPublished: true } },
    {
      enabled: !!shopInfo?.token && !getThemeId,
      onSuccess: (data) => {
        setTheme(data?.themes?.edges?.[0]?.node);
      },
    },
  );
  const themeId = useMemo(() => getThemeId, [getThemeId]);

  return {
    themeId,
  };
};
